import "react-native-gesture-handler";
import React from "react";
import { enableScreens } from "react-native-screens";
enableScreens();
import AppScreens from "./app/index";

export default function App() {
  return <AppScreens />;
}
